module.exports = __webpack_public_path__ + "img/LogoMovistar01.597ad7aa.png";